import { render, staticRenderFns } from "./ReportingFrequencyDistribution.vue?vue&type=template&id=40157567&scoped=true&"
import script from "./ReportingFrequencyDistribution.vue?vue&type=script&lang=js&"
export * from "./ReportingFrequencyDistribution.vue?vue&type=script&lang=js&"
import style0 from "./ReportingFrequencyDistribution.vue?vue&type=style&index=0&id=40157567&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40157567",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VProgressCircular,VRow,VSpacer})
